import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const GroupDetailConfigurationSkeleton = () => {
  return (
    <>
      <Styles.DetailsContainer>
        <Skeleton variant="text" width={120} height={28} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="text" width={220} height={20} />
      </Styles.DetailsContainer>

      <Divider />

      <Styles.PermissionsContainer>
        <Skeleton variant="text" width={120} height={28} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="rounded" width="100%" height={120} />
        <Skeleton variant="rounded" width="100%" height={120} />
        <Skeleton variant="text" width={140} height={24} />
        <Skeleton variant="rounded" width="100%" height={120} />
      </Styles.PermissionsContainer>
    </>
  )
}

export default GroupDetailConfigurationSkeleton
